import React from 'react'
import axios from 'axios'
import './find-family-profile-search-box.css'
import { baseUrl } from '../../../../assets/Animations'
import { getRequestHeaders } from '../../../../api'

const FindFamilyProfileSearchBox = ({ modalInfo, setModalInfo, getFamilyInfo }) => {
    const [familySuggestions, setFamilySuggestions] = React.useState([])

    const selectTheFamily = (id) => {
        axios.put(`${baseUrl}/student-onboarding/changeId/${modalInfo.todoId}`, {familyId: id}, getRequestHeaders())
        .then(res => {
            setModalInfo(prevState => ({...prevState, familyId: id}))
        })
        .catch(err => {
            console.log(err)
        })
    }
    const getFamilySuggestions = (query) => {
        axios.get(`${baseUrl}/search/${query}`, getRequestHeaders())
        .then(res => {
            setFamilySuggestions(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    return (
        <div className="find-family-profile-search-box__wrapper">
            <div className="find-family-profile-search-box__label">Connect to a family</div>
            <input className='find-family-profile-search-box__search' placeholder='Find a family profile' type="text" onChange={(e) => {getFamilySuggestions(e.target.value)}}/>
            {familySuggestions.map((family, index) => (
                    <div className='find-family-profile-search-box__suggestion' key={index} onClick={() => {selectTheFamily(family.familyId)}}>{family.primaryParentName} {family.familyName} ({family.school})</div>
                )
            )}
        </div>
    )
}
export default FindFamilyProfileSearchBox;